import React from "react";
import {
  FloatingFocusManager,
  FloatingOverlay,
  FloatingPortal,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
} from "@floating-ui/react";

export function Dialog({
  children,
  onOpenChange,
  isOpen,
  style,
}: {
  children: React.ReactNode;
  onOpenChange: (open: boolean) => void;
  isOpen?: boolean;
  style?: React.CSSProperties;
}) {
  const { refs, context } = useFloating({
    open: isOpen,
    onOpenChange: onOpenChange,
  });

  const click = useClick(context);
  const role = useRole(context);
  const dismiss = useDismiss(context, { outsidePressEvent: "mousedown" });

  const { getReferenceProps, getFloatingProps } = useInteractions([click, role, dismiss]);

  return (
    <>
      <FloatingPortal>
        {isOpen && (
          <FloatingOverlay className={"pyne-dialog__overlay"} lockScroll>
            <FloatingFocusManager context={context}>
              <div style={style} className={"pyne-dialog"} ref={refs.setFloating} {...getFloatingProps()}>
                {children}
              </div>
            </FloatingFocusManager>
          </FloatingOverlay>
        )}
      </FloatingPortal>
    </>
  );
}
